import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { hideBanner } from '../store/layout-banner-reducer';
export default function DefaultLayout({ children }) {
	const dispatch = useDispatch();
	useEffect(() => {
		if (!location.pathname.includes('/preview')) {
			dispatch(hideBanner());
		}
	}, [location.pathname, dispatch]);
	return (
		<div className="page-content">
			{children}
		</div>
	);
}

DefaultLayout.propTypes = {
	children: PropTypes.any,
};
